export const MIN_SCREEN_WIDTH_ENOUGH_TO_SHOW_NOTES = 576;
